import { jsx as _jsx } from "react/jsx-runtime";
import AvinorLogoLink from "@components/AvinorLogo/AvinorLogoLink";
import "./Footer.scss";
const Footer = () => {
    return (_jsx("div", { className: "aop-footer", children: _jsx("div", { className: "aop-footer__wrapper", children: _jsx(AvinorLogoLink, { to: "/" }) }) }));
};
export default Footer;
